(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-accordions-dz"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('dz-product-accordions')) return;
  let instance = 0;
  customElements.define('dz-product-accordions', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.frame = requestAnimationFrame(() => {
        const prefix = 'dz-product-panel-' + (++instance);
        this.querySelectorAll('.dz-product-accordion').forEach((accordion, index) => {
          const button = accordion.querySelector('.dz-product-accordion__summary');
          const content = accordion.querySelector('.dz-product-accordion__content');
          if (!button || !content) return;
          button.id = prefix + '-' + index + '-button';
          content.id = prefix + '-' + index;
          button.setAttribute('aria-controls', content.id);
          content.setAttribute('aria-labelledby', button.id);
          content.setAttribute('role', 'region');
          const update = (open) => {
            if (!open && content.contains(document.activeElement)) button.focus();
            accordion.classList.toggle('is-open', open);
            button.setAttribute('aria-expanded', String(open));
            content.setAttribute('aria-hidden', String(!open));
            content.inert = !open;
          };
          update(accordion.classList.contains('is-open'));
          button.addEventListener('click', () => update(!accordion.classList.contains('is-open')), { signal: this.controller.signal });
        });
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["retailer-icon-links"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('dz-retailer-tracking')) return;
  const impressions = new Set();
  const firstClicks = new Set();
  const retailers = [
    ['instacart.com', 'Instacart'],
    ['doordash.com', 'DoorDash'],
    ['walmart.com', 'Walmart'],
    ['target.com', 'Target'],
    ['sprouts.com', 'Sprouts'],
    ['costco.com', 'Costco'],
    ['sameday.costco.com', 'Costco']
  ];
  class RetailerTracking extends HTMLElement {
    connectedCallback() {
      if (window.Shopify?.designMode || this.controller) return;
      this.controller = new AbortController();
      this.visibleLinks = new Set();
      this.pending = [];
      this.attempts = 0;
      const signal = this.controller.signal;
      const publish = (name, data) => {
        this.pending.push({ name, data });
        this.flush();
      };
      const details = (link) => {
        const url = new URL(link.href, location.href);
        const host = url.hostname.toLowerCase().replace(/^www\./, '');
        const known = retailers.find(([domain]) => host === domain || host.endsWith('.' + domain));
        const label = link.dataset.retailerLabel?.trim();
        const named = retailers.find(([, name]) => label && label.toLowerCase().includes(name.toLowerCase()));
        const retailer = named?.[1] || (label && label !== 'Shop this product' ? label : known?.[1] || host);
        return {
          retailer_name: retailer,
          retailer_domain: host,
          retailer_slot: link.dataset.retailerSlot,
          product_id: this.dataset.productId,
          product_name: this.dataset.productName,
          product_handle: this.dataset.productHandle,
          link_url: url.origin + url.pathname,
          page_location: location.origin + location.pathname,
          placement: 'product_retailer_icons'
        };
      };
      const keyFor = (data) => JSON.stringify([data.product_id, data.retailer_name]);
      const impression = (data) => {
        const key = keyFor(data);
        if (impressions.has(key)) return;
        impressions.add(key);
        publish('farms1836:retailer_impression', data);
      };
      const visible = (link) => {
        const style = getComputedStyle(link);
        return link.getClientRects().length > 0 && style.visibility === 'visible' && style.display !== 'none';
      };
      this.addEventListener('click', (event) => this.trackClick(event), { signal });
      this.addEventListener('auxclick', (event) => {
        if (event.button === 1) this.trackClick(event);
      }, { signal });
      this.trackClick = (event) => {
        const link = event.target.closest('a.dz-retailer-links__link');
        if (!link || !this.contains(link) || !visible(link)) return;
        try {
          const data = details(link);
          impression(data);
          const key = keyFor(data);
          if (!firstClicks.has(key)) {
            firstClicks.add(key);
            publish('farms1836:retailer_first_click', data);
          }
          publish('farms1836:retailer_click', data);
        } catch (_) {}
      };
      const recordVisible = () => {
        if (document.visibilityState !== 'visible') return;
        this.visibleLinks.forEach((link) => {
          if (visible(link)) {
            try { impression(details(link)); } catch (_) {}
          }
        });
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) this.visibleLinks.add(entry.target);
            else this.visibleLinks.delete(entry.target);
          });
          recordVisible();
        }, { threshold: [0, 0.5] });
        this.querySelectorAll('a.dz-retailer-links__link').forEach((link) => this.observer.observe(link));
      }
      document.addEventListener('visibilitychange', recordVisible, { signal });
      this.timer = setInterval(() => {
        this.flush();
        if (++this.attempts >= 60) clearInterval(this.timer);
      }, 500);
    }
    flush() {
      const analytics = window.Shopify?.analytics;
      if (typeof analytics?.publish !== 'function') return;
      while (this.pending.length) {
        const event = this.pending.shift();
        try {
          Promise.resolve(analytics.publish(event.name, event.data)).catch(() => {});
        } catch (_) {}
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      clearInterval(this.timer);
      this.controller = null;
      this.pending = [];
    }
  }
  customElements.define('dz-retailer-tracking', RetailerTracking);
})();
  } catch(e) { console.error(e); }
})();

})();
